import React from 'react';

import { AbstractRoute } from '@/core/lib/router/route';
import AdSense from '@/next/lib/ads/AdSense';
import OptiDigital from '@/next/lib/ads/OptiDigital';

const AdsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const {
    common: { adsense },
  } = AbstractRoute.useCommonParams();

  if (adsense === 1) {
    return <AdSense>{children}</AdSense>;
  }

  return <OptiDigital>{children}</OptiDigital>;
};

export default AdsProvider;
